var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('btn-icon',{attrs:{"disabled":_vm.model.loading || _vm.disabled,"icon":_vm.isVoted?'heart':'heart-outline',"title":`Нравится ${_vm.count}`,"color":"primary"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.isVoted ? _vm.unvote() : _vm.vote()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }